import React from 'react';
import { Link } from 'react-router-dom'; // Import Link for navigation
import styles from './AppBar.module.css';

const AppBar = ({ onNavigate }) => {
  return (
    <header className={styles.appBar}>
      <a href="/" onClick={() => onNavigate('home')}>
        <img src="/logo-bar.png" alt="Your Logo" className={styles.logo} />
      </a>

      <nav className={styles.nav}>
        <ul>
          <li>
            <button onClick={() => onNavigate('who-we-are')}>Who we are</button>
          </li>
          <li>
            <button onClick={() => onNavigate('how-it-works')}>How it works</button>
          </li>
          <li>
            <button onClick={() => onNavigate('safety-tips')}>Safety tips</button>
          </li>
          <li>
            <button onClick={() => onNavigate('community-guidelines')}>Community guidelines</button>
          </li>
        </ul>
      </nav>
    </header>
  );
};

export default AppBar;
